var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M15.9854 6.97154C13.8165 8.63249 13.4389 11.7818 15.142 14.0058C16.8451 16.2298 19.984 16.6862 22.1529 15.0253C24.3218 13.3644 24.6994 10.215 22.9963 7.99103C21.2932 5.76703 18.1543 5.31061 15.9854 6.97154Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    width: 18,
    height: 8.91213,
    rx: 4.45606,
    transform: "matrix(-0.607996 -0.79394 -0.79394 0.607996 18.8221 22.3067)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.620d28abfbf266d8978dcd3fa300f70e.svg";
export { ForwardRef as ReactComponent };